import { patchedStoryblokEditable } from 'apps/urban/utils/patchedStoryblokEditable';

import { TagWrapper } from './HeroTag.style';
import { THeroTagProps } from './HeroTag.types';

export const HeroTag = ({ blok, blok: { title } }: THeroTagProps) => (
  <div {...patchedStoryblokEditable(blok)}>{title && <TagWrapper>{title}</TagWrapper>}</div>
);
